import { useEffect, useState } from "react";
import UserService from "../service/UserService";
import APIError from "../service/APIError";

export const PATH_HOME = "/home";
export const PATH_SUBSCRIBE = "/subscribe";
export const PATH_SUBSCRIPTION = "/my/subscription";
export const PATH_DOMAINS = "/my/domains";
export const PATH_PROFILE = "/my/profile";
export const PATH_THIRD_PARTY = "/my/third-party";

export const WINDOW_NEW = "_blank";
export const WINDOW_SAME = "_self";

const useOpenAccount = ({ windowTarget = WINDOW_SAME, path = "" }) => {
  const [shouldOpen, setShouldOpen] = useState(false);

  const open = () => {
    setShouldOpen(true);
  };

  useEffect(() => {
    if (shouldOpen) {
      const openWindow = async () => {
        setShouldOpen(false);
        try {
          const { loginURL } = await UserService.getAccountLoginURL();
          let queryParams = "?ssosource=showit-design-app";
          if (path && path.length > 0) {
            queryParams = `${queryParams}&path=${encodeURIComponent(path)}`;
          }
          const url = `${loginURL}${queryParams}`;
          window.open(url, windowTarget);
        } catch (err) {
          console.log("Failed to get account signin", err);
          if (APIError.handle(err)) {
            return;
          }
        }
      };

      openWindow();
    }
  }, [shouldOpen, path, windowTarget]);

  return [open];
};

export default useOpenAccount;
